export const PAYMENT_TERMS = {
  "100": {
    label: "100% all'ordine",
    schedule: [{ label: "100% all'ordine", percent: 100 }],
  },
  "50_50": {
    label: "50% Acconto / 50% Saldo",
    schedule: [
      { label: "Acconto 50%", percent: 50 },
      { label: "Saldo 50%", percent: 50 },
    ],
  },
  "30_40_30": {
    label: "30% / 40% / 30%",
    schedule: [
      { label: "Acconto 30%", percent: 30 },
      { label: "Avanzamento 40%", percent: 40 },
      { label: "Saldo 30%", percent: 30 },
    ],
  },
};

export const PREVIDENZA_LABELS = {
  nessuno: null,
  inps: "Rivalsa INPS 4%",
  cassa: "Cassa Professionale {rate}%",
};

const FORFETTARIO_NOTE =
  "Operazione in franchigia da IVA ai sensi dell'art. 1, commi da 54 a 89, della Legge n. 190/2014 e s.m.i. Il compenso non è soggetto a ritenuta d'acconto ai sensi dell'art. 1, comma 67, della medesima Legge.";
const OCCASIONALE_NOTE =
  "Prestazione occasionale ai sensi dell'art. 2222 c.c. e dell'art. 67, comma 1, lett. l), del TUIR. Operazione fuori campo IVA ai sensi dell'art. 5 del DPR n. 633/1972.";
const OCCASIONALE_RITENUTA_NOTE =
  "Compenso soggetto a ritenuta d'acconto del 20% ai sensi dell'art. 25 del DPR n. 600/1973.";

export function needsBolloNote(totals) {
  return !!totals.bolloDue;
}

export function legalAuto(totals, bolloId = "") {
  const parts = [];
  if (totals.isOccasionale) {
    parts.push(OCCASIONALE_NOTE);
    if (totals.ritenuta > 0) parts.push(OCCASIONALE_RITENUTA_NOTE);
  } else if (totals.regimeEff === "forfettario") parts.push(FORFETTARIO_NOTE);
  if (totals.bolloDue) {
    const who = totals.addebitoBollo ? "addebitata al cliente" : "a carico dell'emittente";
    const id = (bolloId || "").trim();
    parts.push(`Imposta di bollo di 2,00 € dovuta sulla fattura (importi non soggetti a IVA oltre 77,47 €), ${who}.` + (id ? ` ID marca da bollo: ${id}.` : ""));
  }
  return parts.join(" ");
}

export function legalNotesText(quote, totals) {
  if (quote.status === "accettato" && quote.legal_notes_frozen != null) return quote.legal_notes_frozen;
  if (quote.legal_notes_custom != null) return quote.legal_notes_custom;
  return legalAuto(totals, quote.bollo_id);
}

const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

function applyDiscount(base, dtype, dvalue) {
  dvalue = dvalue || 0;
  if (dtype === "percent") return r2((base * Math.min(Math.max(dvalue, 0), 100)) / 100);
  if (dtype === "amount") return r2(Math.min(Math.max(dvalue, 0), base));
  return 0;
}

export function initSelections(items, groups) {
  const s = {};
  (items || []).forEach((it) => {
    if (it.item_type === "optional") s[it.id] = { enabled: it.enabled_default !== false };
    else if (it.item_type === "variable") s[it.id] = { quantity: it.quantity };
  });
  (groups || []).forEach((g) => {
    const pkgs = g.packages || [];
    if (!pkgs.length) return;
    const def = pkgs.find((p) => p.default_selected) || pkgs[0];
    s[g.id] = { package: def.id };
  });
  return s;
}

export function earlyActiveNow(early_discount_type, early_discount_deadline) {
  if (!early_discount_type || early_discount_type === "none") return false;
  if (!early_discount_deadline) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dl = new Date(early_discount_deadline + "T23:59:59");
  return today <= dl;
}

// cfg: { tax_regime, previdenza, ritenuta_acconto, addebito_bollo, client_type, payment_terms }
export function computeTotals({
  items,
  selections,
  tax_regime,
  previdenza = "nessuno",
  cassa_rate = 4,
  ritenuta_acconto = false,
  addebito_bollo = false,
  client_type = "business",
  payment_terms = "50_50",
  global_discount_type = "none",
  global_discount_value = 0,
  early_discount_type = "none",
  early_discount_value = 0,
  early_active = false,
  promo_discount_type = "none",
  promo_discount_value = 0,
  groups = [],
  qty_overrides = {},
}) {
  selections = selections || {};
  const isOccasionale = tax_regime === "occasionale";
  const regimeEff = (tax_regime === "forfettario" || isOccasionale) ? "forfettario" : "ordinario";
  let deliveryDays = 0;
  let imponibileLordo = 0;
  let scontoVoci = 0;
  const lines = [];
  (items || []).forEach((it) => {
    const sel = selections[it.id] || {};
    let enabled = true;
    let qty = it.quantity;
    if (it.item_type === "optional")
      enabled = sel.enabled !== undefined ? sel.enabled : it.enabled_default !== false;
    if (it.item_type === "variable") {
      qty = sel.quantity !== undefined ? sel.quantity : it.quantity;
      qty = Math.max(it.min_qty || 1, Math.min(it.max_qty || 999999, qty));
    }
    if (qty_overrides[it.id] !== undefined) qty = Number(qty_overrides[it.id]);
    const gross = enabled ? (it.unit_price || 0) * qty : 0;
    const disc = enabled ? applyDiscount(gross, it.discount_type || "none", it.discount_value || 0) : 0;
    const net = r2(gross - disc);
    const ivaRate = regimeEff === "ordinario" ? (it.iva_rate != null ? it.iva_rate : 22) : 0;
    if (enabled) {
      imponibileLordo += net;
      scontoVoci += disc;
      deliveryDays += it.work_days || 0;
    }
    lines.push({ ...it, enabled, qty, gross: r2(gross), discount: r2(disc), lineTotal: net, ivaRateEff: ivaRate });
  });

  (groups || []).forEach((g) => {
    const pkgs = g.packages || [];
    if (!pkgs.length) return;
    const sel = selections[g.id] || {};
    let pkg = pkgs.find((p) => p.id === sel.package);
    if (!pkg) pkg = pkgs.find((p) => p.default_selected) || pkgs[0];
    const gross = pkg.price || 0;
    const disc = applyDiscount(gross, pkg.discount_type || "none", pkg.discount_value || 0);
    const net = r2(gross - disc);
    const ivaRate = regimeEff === "ordinario" ? (pkg.iva_rate != null ? pkg.iva_rate : 22) : 0;
    imponibileLordo += net;
    scontoVoci += disc;
    deliveryDays += pkg.work_days || 0;
    lines.push({
      id: pkg.id,
      group_id: g.id,
      title: `${g.title ? g.title + ": " : ""}${pkg.name}`,
      unit_price: gross,
      enabled: true,
      qty: 1,
      gross: r2(gross),
      discount: r2(disc),
      lineTotal: net,
      work_days: pkg.work_days || 0,
      ivaRateEff: ivaRate,
      isPackage: true,
    });
  });

  imponibileLordo = r2(imponibileLordo);
  const scontoGlobale = applyDiscount(imponibileLordo, global_discount_type, global_discount_value);
  const impAfterGlobal = r2(imponibileLordo - scontoGlobale);
  const scontoEarly = early_active ? applyDiscount(impAfterGlobal, early_discount_type, early_discount_value) : 0;
  const impAfterEarly = r2(impAfterGlobal - scontoEarly);
  const scontoPromo = applyDiscount(impAfterEarly, promo_discount_type, promo_discount_value);
  const imponibile = r2(impAfterEarly - scontoPromo);
  const scontoTotale = r2(scontoVoci + scontoGlobale + scontoEarly + scontoPromo);

  const factor = imponibileLordo > 0 ? imponibile / imponibileLordo : 0;
  const contributoRate = previdenza === "inps" ? 4 : previdenza === "cassa" ? Number(cassa_rate) || 4 : 0;
  const contributo = r2((imponibile * contributoRate) / 100);

  const rateMap = {};
  lines.forEach((ln) => {
    if (!ln.enabled) return;
    const svc = ln.lineTotal * factor;
    const contribShare = imponibile > 0 ? contributo * (svc / imponibile) : 0;
    const base = svc + contribShare;
    const rate = ln.ivaRateEff;
    if (!rateMap[rate]) rateMap[rate] = { imponibile: 0, iva: 0 };
    rateMap[rate].imponibile += base;
    rateMap[rate].iva += (base * rate) / 100;
  });
  let iva = 0;
  const ivaBreakdown = [];
  Object.keys(rateMap)
    .map(Number)
    .sort((a, b) => b - a)
    .forEach((rate) => {
      const rv = r2(rateMap[rate].iva);
      iva += rv;
      if (rate > 0) ivaBreakdown.push({ rate, imponibile: r2(rateMap[rate].imponibile), iva: rv });
    });
  iva = r2(iva);

  const baseIva = r2(imponibile + contributo);
  const zeroBase = r2(rateMap[0]?.imponibile || 0);
  const bolloDue = (regimeEff === "forfettario" ? baseIva : zeroBase) > 77.47;
  const addebitoBollo = !!addebito_bollo;
  const bollo = bolloDue && addebitoBollo ? 2.0 : 0;
  const totaleLordo = r2(baseIva + iva + bollo);

  let ritenuta = 0;
  if (client_type === "business" && ((regimeEff === "ordinario" && ritenuta_acconto) || isOccasionale)) {
    const baseRit = previdenza === "inps" ? imponibile + contributo : imponibile;
    ritenuta = r2(baseRit * 0.2);
  }
  const netto = r2(totaleLordo - ritenuta);

  const sched = (PAYMENT_TERMS[payment_terms] || PAYMENT_TERMS["50_50"]).schedule;
  const installments = sched.map((t) => ({ ...t, amount: r2((netto * t.percent) / 100) }));


  return {
    imponibileLordo,
    scontoVoci: r2(scontoVoci),
    scontoGlobale,
    scontoEarly,
    scontoPromo,
    earlyActive: !!(early_active && scontoEarly > 0),
    scontoTotale,
    imponibile,
    contributo,
    contributoRate: contributo ? contributoRate : 0,
    contributoLabel: PREVIDENZA_LABELS[previdenza]?.replace("{rate}", contributoRate) || null,
    previdenza,
    baseIva,
    iva,
    ivaRate: iva ? 22 : 0,
    ivaBreakdown,
    bollo,
    bolloDue,
    addebitoBollo,
    totaleLordo,
    ritenuta,
    ritenutaRate: ritenuta ? 20 : 0,
    netto,
    deliveryDays,
    installments,
    regimeEff,
    isOccasionale,
    legalNote: legalAuto({ regimeEff, isOccasionale, ritenuta, bolloDue, addebitoBollo }),
    lines,
  };
}
